import Hero from "./sections/Hero";
import About from "./sections/About";
import Services from "./sections/Services";
import Projects from "./sections/Projects";
import WhyUs from "./sections/WhyUs";
import Contact from "./sections/Contact";
import Footer from "./sections/Footer";
import logo from "./img/logo.png";

import "./style.css";

function App() {
  return (
    <div>

      <nav className="navbar">
        <div className="nav-inner">

          <div className="logo">

            <img
              src={logo}
              alt="3 Point Signs"
            />

          </div>

          <div className="nav-links">
            <a href="#about">About</a>
            <a href="#services">Services</a>
            <a href="#projects">Projects</a>
            <a href="#whyus">Why Us</a>
            <a href="#contact">Contact</a>
          </div>

        </div>
      </nav>

      <Hero />

      <section id="about" className="section">
        <About />
      </section>

      <br></br>
      <section id="services" className="section section-alt">
        <Services />
      </section>

      <br></br>
      <section id="projects" className="section">
        <Projects />
      </section>

      <br></br>
      <section id="whyus" className="section section-alt">
        <WhyUs />
      </section>

      <br></br>
      <section id="contact" className="section">
        <Contact />
      </section>

      <br></br>
      <Footer />

    </div>
  );
}

export default App;